import { z } from "zod";

import { BillingTypeTermValidation } from "@/lib/gql/__generated__/graphql";
import {
	AdditionalFeeItemInputSchema,
	BillingTypeTermValidationSchema,
	HotelPolicyI18nInputSchema,
	QuestionItemInputSchema,
} from "@/lib/zod/__generated__/validation-schema";

import {
	chillnnDateZodSchema,
	hotelInfoZodSchema,
	priceObjectZodSchema,
} from "../../../../../../_shared/validation-schema/validation-schema";

import type { ZodError } from "zod";

export const hotelPolicyI18nInputZodSchema = HotelPolicyI18nInputSchema.extend({
	hotelInfo: hotelInfoZodSchema,

	// 追加料金
	additionalFees: z.array(
		AdditionalFeeItemInputSchema.extend({
			name: z.string().min(1),
			price: priceObjectZodSchema,

			billingTypeTermValidation: BillingTypeTermValidationSchema.nullish(),
			termValidationApplyStartDt: chillnnDateZodSchema.nullish(),
			termValidationApplyEndDt: chillnnDateZodSchema.nullish(),
		}).refine(({ billingTypeTermValidation, termValidationApplyStartDt, termValidationApplyEndDt }) => {
			if (billingTypeTermValidation === BillingTypeTermValidation.LimitedAnnually) {
				if (!!termValidationApplyStartDt && !!termValidationApplyEndDt) {
					return termValidationApplyStartDt < termValidationApplyEndDt;
				}
			}

			return true;
		}),
	),

	// 事前質問
	questions: z.array(
		QuestionItemInputSchema.extend({
			question: z.string().min(1).max(8_000),
			options: z.array(z.string().min(1).max(500)).nullish(),
			required: z.boolean().nullish(),
		}),
	),
});

export type HotelPolicyI18nZodSchemaType = z.infer<typeof hotelPolicyI18nInputZodSchema>;

export type HotelPolicyI18nZodParseErrorType = ZodError<HotelPolicyI18nZodSchemaType>;
